// extracted by mini-css-extract-plugin
module.exports = {"defaultChartColors":"#92d5f0,#43b6dd,#35adb8,#59ac82,#83ac70,#fea23f,#ff823a,#fc5e3a,#cd4e3e,#864a4a,#53464c"};